import React from 'react';
import { useI18n } from 'nordic/i18n';
import { ui } from '@credits-utils/constants';
import { Typography } from '@andes-landings/typography';
import { Image } from 'nordic/image';
import SharedPropsContext from '../../../../../contexts/SharedProps';
import { getEducationalSectionContent } from '../../content/educationalSection';
import EducationalCard from './components/EducationalCard';
import Miscelanea from '../Miscelanea';

const { TYPOGRAPHY } = ui;

const EducationalSection = () => {
  const {
    isMobile,
  } = React.useContext(SharedPropsContext);

  const { i18n } = useI18n();

  const { title, subtitle, steps: { one, two, three, four } } = getEducationalSectionContent({ i18n });

  const getLine = () => !isMobile
 && (
   <Image
     onload="on"
     className="educational-section__line"
     src="buyers/educational/line.png"
     alt="line"
   />
 );

  return (
    <section className="educational-section">
      <Miscelanea />
      <Typography
        className="educational-section__title"
        component={TYPOGRAPHY.COMPONENT.H1}
        type={TYPOGRAPHY.TYPE.TITLE}
        size={TYPOGRAPHY.SIZE.XL}
        color={TYPOGRAPHY.COLOR.PRIMARY}
      >
        {title}
      </Typography>
      <h2 className="educational-section__subtitle">{subtitle}</h2>
      <div className="educational-section__cards">
        <div>
          {getLine()}
        </div>
        <EducationalCard data={one} />
        <EducationalCard data={two} />
        <EducationalCard data={three} />
        <EducationalCard data={four} />
      </div>
    </section>
  );
};

export default EducationalSection;
